

























import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import { Timestamp, UsersResp_User } from '@/apiv3/index'
import auth from '@/auth'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import helpers from '@/helpers'

@Component({ components: { PulseLoader } })
export default class Users extends Vue {
  public users!: UsersResp_User[]
  public loaded = false

  mounted () {
    auth.adminClient().Users({}).then((resp) => {
      this.users = resp.users
    }).finally(() => {
      this.loaded = true
    })
  }

  formatDateTs (value: Timestamp | undefined): string {
    return helpers.formatDateTs(value)
  }
}
